import type { JSX, ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

interface TabConfig {
  id: string;
  label: string;
}

interface TabNavigationProps {
  activeTab: string;
  onSelect: (tabId: string) => void;
  tabs: TabConfig[];
  actions?: ReactNode;
  className?: string;
}

export function TabNavigation({
  activeTab,
  onSelect,
  tabs,
  actions,
  className,
}: TabNavigationProps): JSX.Element {
  return (
    <div className={cn('w-full border-b border-[var(--border-default)]', className)}>
      <div className="flex w-full items-center justify-between">
        <div className="min-w-0 flex-1">
          <Tabs value={activeTab} onValueChange={onSelect} className="w-full">
            <TabsList className="h-12 w-full justify-start gap-6 bg-transparent p-0">
              {tabs.map((tab) => (
                <TabsTrigger
                  key={tab.id}
                  value={tab.id}
                  className="relative h-12 rounded-none border-b-2 border-transparent bg-transparent px-1 pb-3 pt-3 font-semibold text-text-secondary shadow-none transition-none data-[state=active]:border-brand-blue-500 data-[state=active]:text-brand-blue-600 data-[state=active]:shadow-none hover:text-text-primary focus-visible:ring-0 focus-visible:outline-none"
                >
                  {tab.label}
                </TabsTrigger>
              ))}
            </TabsList>
          </Tabs>
        </div>
        {actions ? <div className="flex items-center gap-3 py-2">{actions}</div> : null}
      </div>
    </div>
  );
}
